@if (tag(); as tag) {
  @if (!readonly) {
    <common-chip [clickable]="true" [ttMenuPosition]="Position.BOTTOM_RIGHT" [ttMenuTriggerFor]="menu" [variant]="tagVariant()"
      >{{ tagLabel() | transloco }}
      @if (!!tag.message) {
        <mat-icon [icon]="'info'" [iconSize]="14" [ttTooltip]="'GuidelineUpdateTag.TagInfoTooltip' | transloco" />
      }
    </common-chip>
  } @else {
    <common-chip [variant]="tagVariant()" (click)="onViewMessage($event)">
      {{ tagLabel() | transloco }}
      @if (!!tag.message) {
        <mat-icon [icon]="'info'" [iconSize]="14" [ttTooltip]="'GuidelineUpdateTag.TagInfoTooltip' | transloco" />
      }
    </common-chip>
  }

  <tt-menu #menu>
    <button ttMenuItem (click)="handleTagUpdate({ isActive: !tag.isActive })">
      <mat-icon [icon]="tag?.isActive ? 'eye-off' : 'eye'" />
      {{ (tag.isActive ? 'GuidelineUpdateTag.DeactivateTag' : 'GuidelineUpdateTag.ActivateTag') | transloco }}
    </button>
    @if (!tag.message) {
      <button ttMenuItem (click)="handleAddMessage()">
        <mat-icon [icon]="'message-circle-warning'" />
        {{ 'GuidelineUpdateTag.AddMessage' | transloco }}
      </button>
    } @else {
      <button ttMenuItem (click)="handleAddMessage()">
        <mat-icon [icon]="'message-circle-warning'" />
        {{ 'GuidelineUpdateTag.ShowMessage' | transloco }}
      </button>
      <button ttMenuItem (click)="handleTagUpdate({ message: undefined })">
        <mat-icon [icon]="'trash'" />
        {{ 'GuidelineUpdateTag.RemoveMessage' | transloco }}
      </button>
    }
  </tt-menu>
}

<ng-template #addMessagePopover let-data>
  <div class="tt-guideline-update-tag_add-message-popover">
    <common-rich-text-editor
      [editorContent]="data.tag.message"
      [placeholder]="'GuidelineUpdateTag.AddMessagePlaceholder' | transloco"
      [toolbarType]="'basic'"
      (editorContentChange)="handleTagUpdate({ message: $event })" />
  </div>
</ng-template>

<ng-template #viewMessagePopover let-data>
  <div class="tt-guideline-update-tag_view-message-popover">
    <common-rich-text-view [content]="data.tag.message" />
  </div>
</ng-template>
